import React from 'react';
import { useDropdown } from './DropdownContext';

function ButtonSelect({ readOnly, tabKeyStatus }) {
  const { decoratorRef, handleToggleDropdown } = useDropdown();

  const handleToggle = () => {
    if (readOnly) {
      return;
    }
    handleToggleDropdown();
  };

  return (
    <div className={'dropdown-multi-select__header'} ref={decoratorRef}>
      <button
        id='form-dropdown-btn'
        className={[
          readOnly ? 'btn-fixedsize--disabled' : '',
          'btn-fixedsize--sub btn-history',
        ].join(' ')}
        onClick={handleToggle}
        tabIndex={tabKeyStatus}
      >
        履歴から選択
      </button>
    </div>
  );
}

export default ButtonSelect;



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/ButtonSelect.jsx